import { formatInTimeZone } from 'date-fns-tz';

import { formatTimestampInTimezone } from 'utils/time';

function isoOffsetSuffixToTz(localTimestamp: string): string | null {
  const match = localTimestamp.match(/([+-])(\d{2})(\d{2})$/);
  if (!match) return null;
  return `${match[1]}${match[2]}:${match[3]}`;
}

export function formatIsoLocalTimestamp(localTimestamp: string, formatString: string): string {
  const d = new Date(localTimestamp);
  const tz = isoOffsetSuffixToTz(localTimestamp);
  if (!Number.isFinite(d.getTime()) || !tz) return '';
  return formatInTimeZone(d, tz, formatString);
}

export function formatCamMatchDateTime(localTimestamp: string): string {
  return formatIsoLocalTimestamp(localTimestamp, 'EEE d MMM · haaa');
}

/** Forecast comparison bucket label from real UTC `datetime` and spot `utcOffset`. */
export function formatForecastComparisonLabel(datetime: number, utcOffset: number): string {
  if (!Number.isFinite(datetime) || !Number.isFinite(utcOffset)) return '';
  return formatTimestampInTimezone(datetime, utcOffset, 'EEE d MMM · haaa');
}
